export const main = {
    "name": "Khalid Saifullah",
    "occupation": "Founder of KS Devware",
    "description": "Software Engineer | Entrepreneur",
    "image": "profilepic.jpg",
    "bio": "As the founder of KS Devware (software development company), I am Khalid Saifullah. A young entrepreneur. With nearly 4 years of experience, I’m a software engineer (full-stack web & mobile) and UI/UX designer. Worked as a senior lead full-stack developer at OpticEngine had been a rewarding experience. Moreover, I work on a few startups aimed at the Bangladesh, Russian, Chinese, American, and Dutch markets. Among the companies and entrepreneurs I have worked with are DP-Websolutions, Ganlax group, Hyvinvoivin, Happy-Dairy, Arrtal, FN Softwares & institute, and many more. Developing software for the world of intent is something I'm passionate about and I'm dedicated to making the world of intent easy and affordable for everyone.",
    "email": "khalideofficial@gmail.com",
    "phone": "+880 17874 63481",
    "quote": "The universe is a pretty big place. If it's just us.",
    "address": "Badda, Dhaka, Bangladesh",
    "website": "https://khaliddev.com",
    "resumedownload": "https://docs.google.com/document/d/1APRM9vrs3bSMCw41v4UHBuLj1xRmBdJ0NLxxpAoWlrY/edit?usp=sharing",
    "social": [
        {
            "name": "linkedin",
            "url": "https://www.linkedin.com/in/coderkhalid",
            "iconName": "logo-linkedin"
        },
        {
            "name": "youtube",
            "url": "https://www.youtube.com/c/khalidsaifullahKS",
            "iconName": "logo-youtube"
        },
        {
            "name": "twitter",
            "url": "https://twitter.com/coderkhalid",
            "iconName": "logo-twitter"
        },
        {
            "name": "facebook",
            "url": "https://www.facebook.com/khalide.saifullah",
            "iconName": "logo-facebook"
        },
        {
            "name": "instagram",
            "url": "https://www.instagram.com/coderkhalid/",
            "iconName": "logo-instagram"
        },
        {
            "name": "github",
            "url": "https://github.com/coderkhalide",
            "iconName": "logo-github"
        }
    ]
}

export const about = {
    "bio": "I am a software <br /><span class='text-primary'>engineer</span> who cares<br /> about the code and the people.",
    "ido": "<p>WEB DEVELOPMENT</p><p>APP DEVELOPMENT</p><p>UI/UX DESIGN</p><p>FRONT-END DEVELOPMENT</p><p>BACK-END DEVELOPMENT</p><p>FULL-STACK DEVELOPMENT</p>",
    "years": 4,
    "image": "img/profilepic.jpg",
    // "video": "https://www.youtube.com/watch?v=ghQd1PbzVaY",
    "resumedownload": "https://docs.google.com/document/d/1APRM9vrs3bSMCw41v4UHBuLj1xRmBdJ0NLxxpAoWlrY/edit?usp=sharing",
}

export const works = [
    [
        
        {
            "company": "DP-Websolutions",
            "title": "Full-Stack Developer & UI/UX designer",
            "image": "img/behance.png",
            "years": "July 2020 - Present",
            "description": "• Dedicated years of collaborative effort resulted in 30% increase in company revenue <br />• Responsible for testing applications and looking for bugs & monitoring website performance <br />• Responsible for application code and UI/UX design <br />• Built responsive custom WordPress themes from scratch also with DIVI theme <br />• Optimized company website for performance and Search Engine Optimization"
        },
        {
            "company": "OpticEngine",
            "title": "Senior Lead Full-Stack Web & Mobile Developer",
            "image": "img/behance.png",
            "years": "June 2021 - October 21",
            "description": "• Built websites with React JS and node js as backend <br />• Designing web and mobile apps mockups using Figma <br />• Designed and built the User Interface of the mobile app with React-native <br />• Assist the backend developer on ongoing development projects <br />• Participating in all decision-making processes which includes the database design, tooling, deployment processes etc"
        },
        {
            "company": "FN Softwares & institute",
            "title": "Trainer & Full-Stack Developer",
            "image": "img/behance.png",
            "years": "Aug 20 - Present",
            "description": "• Trained programming over 500+ students on 2 successful courses <br />• Developed beta version of 'eSomaz (a social media)' app, used by 20K+ active users (increased active user by 25%) <br />• Developed a VS Code Extension for 'eSomaz' which helped to connect programmers <br />• Worked as an adviser on decision-making processes • Motivated jr developers on programming & life "
        },
    ],
    [
        {
            "company": "Ganlax Group",
            "title": "Web Developer",
            "image": "img/behance.png",
            "years": "May 20 - Present",
            "description": "• Built the company website with custom WordPress themes from scratch <br />• Optimized company website for performance and Search Engine Optimization <br />• Developed Custom Post Types and created custom fields with ACF plugins <br />• Sliced up design assets from Photoshop files when building custom themes <br />• Performed maintenance tasks on pre-existing sites using the Infinite WP dashboard, such as updating plugins, ensuring backups are running, and running security scans"
        },
        {
            "company": "KS Devware",
            "title": "Founder",
            "image": "img/behance.png",
            "years": "March 2021 - Present",
            "description": "• Developing revenue-generating applications at both small and large scales <br />• Providing comprehensive maintenance support <br />• Improving the user interface <br />• Building apps for self-health and helping the nation"
        },
        {
            "company": "WorksLee",
            "title": "Founder",
            "image": "img/behance.png",
            "years": "Januery 2022 - Present",
            "description": "• WorksLee is a peer-to-peer marketplace designed to help people manage their daily workload. It's a place where we are empowering small local entrepreneurs. and helping people to earn by part-time handy work."
        },
    ]
]

export const skills = {
    title: "My mission is to create an impact <span class='text-primary'>globally</span>",
    subtitle: "Developing software for the world of intent is something I'm passionate about and I'm dedicated to making the world of intent easy and affordable for everyone.",
    skills: [
        {
            "title": "Ninja at",
            skills: ["JavaScript", "React JS", "React Native", "Node JS"]
        },
        {
            "title": "Front-end",
            skills: ["JavaScript", "React JS", "Next JS", "HTML/CSS", "SCSS", "UI/UX Design", "Jquery", "Redux"]
        },
        {
            "title": "Back-end",
            skills: ["Node JS", "Express JS", "Rest API", "PHP"]
        },
        {
            "title": "Database",
            skills: ["MySQL", "MongoDB", "Firebase", "redis"]
        },
        {
            "title": "App development",
            skills: ["React Native"]
        },
        {
            "title": "Game development",
            skills: ["unity", "C#", "C"]
        },
        {
            "title": "Payment",
            skills: ["Stripe", "Paypal", "SslCommerz", "Bkash"]
        },
        {
            "title": "Cloud",
            skills: ["Google", "AWS", "Digital ocean", "Heroku", "Vercel"]
        },
        {
            "title": "Libraries",
            skills: ["Tailwind CSS", "Bootstrap", "Material UI"]
        },
        {
            "title": "Others",
            skills: ["Git", "GitHub", "PWA", "Figma", "AJAX", "WordPress", "Google Map", "Mapbox", "blockchain"]
        },
    ]
}

export const projects = [
    {
        "title": "Business website",
        "category": "Website",
        "image": "business2.png",
        "url": "https://megakit-web.netlify.app"
    },
    {
        "title": "Zeppto website",
        "category": "Website",
        "image": "zeptto.png",
        "url": "https://zeppto.netlify.app"
    },
    {
        "title": "Decentralized chat application",
        "category": "Blockchain",
        "image": "web3.png",
        "url": "https://meta-ks.vercel.app/"
    },
    {
        "title": "Food delivery app - (Play store)",
        "category": "App",
        "image": "Kennys Fish & Chips.png",
        "url": "https://play.google.com/store/apps/details?id=com.kennysfishandchips.app"
    },
    {
        "title": "VS Code - Extension for eSomaz",
        "category": "VS Code - Extension",
        "image": "esomax-ext.jpg",
        "url": "https://marketplace.visualstudio.com/items?itemName=coderkhalid.esomaz"
    },
    {
        "title": "Arrtal - Short videos for kids (app)",
        "category": "App",
        "image": "arrtal-app.jpg",
        "url": "https://play.google.com/store/apps/details?id=com.arrtal.arrtalkids"
    },
    {
        "title": "Arrtal creator app",
        "category": "App",
        "image": "creator-app.jpg",
        "url": "https://www.youtube.com/watch?v=QdcaNakkbCI"
    },
    {
        "title": "WhatsApp app clone - React Native",
        "category": "App",
        "image": "whatsapp-app.jpg",
        "url": "https://youtu.be/tMmfcAipfW4"
    },
    {
        "title": "Uber Eats clone - React Native",
        "category": "App",
        "image": "uber-eats.jpg",
        "url": "https://youtu.be/Z7rS3PM3Ap4"
    },
    {
        "title": "Pienipuro.fi",
        "category": "Website",
        "image": "pienipuro.jpg",
        "url": "https://pienipuro.fi"
    },
    {
        "title": "1 to 1 - Video calling application",
        "category": "Website",
        "image": "video-calling.jpg",
        "url": "https://videocall-ks.herokuapp.com"
    },
    {
        "title": "Quotes World App",
        "category": "App",
        "image": "quotes.jpg",
        "url": "https://play.google.com/store/apps/details?id=com.quotes.ksdevware"
    },
    {
        "title": "Airbnb clone - Next JS",
        "category": "Website",
        "image": "airbnb.jpg",
        "url": "https://airbnb-clone-ks.vercel.app"
    },
    {
        "title": "Uber clone - react native",
        "category": "App",
        "image": "uber-clone.jpg",
        "url": "https://expo.io/@coderkhalid/projects/uber-clone"
    },
    {
        "title": "Arrtal app admin dashboard",
        "category": "Admin Website",
        "image": "arrtal-admin.jpg",
        "url": "https://arrtal-admin.vercel.app"
    },
    {
        "title": "Amazon clone - Full-stack with stripe checkout",
        "category": "Website",
        "image": "amazon.jpg",
        "url": "https://pocotep.com"
    },
    {
        "title": "Hyvinvoivin.fi",
        "category": "Website",
        "image": "hyvn.jpg",
        "url": "https://hyvinvoivin.fi"
    },
    {
        "title": "GanlaxGroup.co.uk",
        "category": "Website",
        "image": "ganlax.jpg",
        "url": "http://ganlaxgroup.co.uk"
    },
    {
        "title": "Daily-dairy.com",
        "category": "Website",
        "image": "daily-dairy.jpg",
        "url": "https://daily-dairy.com"
    },
    {
        "title": "KhalidDev.com",
        "category": "Website",
        "image": "resume.jpg",
        "url": "https://coderkhalid.netlify.app"
    },
    {
        "title": "Amanti.com",
        "category": "Website",
        "image": "amanti.jpg",
        "url": "https://amanti-cheese.com"
    },
    {
        "title": "Zoom Clone",
        "category": "Website",
        "image": "zoom-clone.jpg",
        "url": "https://ksdevware.com/dekto"
    },
    {
        "title": "Peer4Tree.com",
        "category": "UI/UX Design",
        "image": "peer4tree.jpg",
        "url": "https://peer4-tree.web.app"
    },
    {
        "title": "MERN blog website",
        "category": "Website",
        "image": "loomly.jpg",
        "url": "https://ks-loomly.herokuapp.com"
    },
    {
        "title": "Whatsapp clone",
        "category": "Website",
        "image": "whatsapp.jpg",
        "url": "https://whatsapp-clone-nextjs-six.vercel.app"
    },
    {
        "title": "KS Classroom (LMS)",
        "category": "Website",
        "image": "classroom.jpg",
        "url": "https://ksdevware.com/classroom"
    },
    {
        "title": "Prolingua.fi",
        "category": "Website",
        "image": "prolingua.jpg",
        "url": "https://prolingua.fi"
    },
    {
        "title": "Peer4Car.com Dashboard UI",
        "category": "UI/UX Design",
        "image": "peer4-admin.jpg",
        "url": "https://www.figma.com/proto/yoQYmaIIPaTQapbwyzr4AI/PEER4-CAR?node-id=1%3A2&viewport=578%2C-192%2C0.38818028569221497&scaling=min-zoom&page-id=0%3A1"
    },
    {
        "title": "Restarant UI design",
        "category": "UI/UX Design",
        "image": "res-ui-deisgn.jpg",
        "url": "https://www.figma.com/proto/CEUw87emTmSLLXCO4hfdSb/RESTAURANT-Theme?node-id=1%3A2&viewport=491%2C87%2C0.25013697147369385&scaling=min-zoom&page-id=0%3A1"
    },
    {
        "title": "Text to Speech",
        "category": "Website",
        "image": "tts.jpg",
        "url": "https://ksdevware.com/old/portfolio/Text_to_speech"
    }
]

export const partners = [
    {
        image: "1.png"
    },
    {
        image: "2.webp"
    },
    {
        image: "4.png"
    },
    {
        image: "workslee.png"
    },
    {
        image: "gorelove.png"
    },
    {
        image: "3.png"
    },
]

export const testimonials = [
    {
        "text": "We are very content and happy wan all the work Khalid Saifullah has done for us! Not only did he just what he had to do, comes up with suggestions and improvements of his owns and points out weaknesses which he in perfect communication is able to improve. Recommended! ",
        "user": "Jason Sindram",
        "company": "CTO at DP-Websolutions"
    },
    {
        "text": "Superb. Great comms, understood the requirement, and delivered quickly. Multiple revisions allowed which were very helpful. I will work with him again.",
        "user": "Bhavesh Patel",
        "company": "CEO at Ganlaxgroup"
    }
]

